import { Box, Typography, Grid } from '@mui/material';
import HeaderWithBar from './HeaderWithBar';
import HorizontalBar from './HorizontalBar';

const Applications = ({data}) => (
  <Box sx={{ py: {xs: 5, md: 15}, px: {xs: 4, md: 20}, display: { xs: 'block', md: 'flex'}, textAlign: "left", gap: '160px',  }}>
    <Box sx={{ flex: '4.8 1' }}>
    <Typography variant="h3"  sx={{ lineHeight: "60px", mb: 4}} >
        {data.title}
    </Typography>
    <img src={data.image} alt="Innovative Solutions" style={{ width: '100%', height: 'auto' }} />
    
    </Box>
    <Box sx={{ flex: '6.8 1' }}>
        <Box my={2}>
            <Typography variant='body1' fontWeight="bold" mb={1}>Description</Typography>
            <Typography variant='subtitle1'>{data.description}</Typography>
        </Box>
        <Box  mb={2}>
            <Typography variant='body1' fontWeight="bold" mb={1}>Applications</Typography>
            <ol>
                {
                    data.applications.map(application=>(
                        <li><Typography variant='subtitle1'>{application}</Typography></li>
                    ))
                }
            </ol>
        </Box>
        <Box>
            <Typography variant='body1' fontWeight="bold" mb={1}>Benefits</Typography>
            <ol>
                {
                    data.benefits.map(benefit=>(
                        <li><Typography variant='subtitle1'>{benefit}</Typography></li>
                    ))
                }
            </ol>
        </Box>
    </Box>
  </Box>
);

export default Applications;
